import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {first} from 'rxjs/operators';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {CommandUtil} from '../../../global/commandutil';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoFileService} from '../../../service/info/service-thongbaofile';
import {ThongBaoFile} from '../../../models/info/thongbaofile';
import {ThongBao} from '../../../models/info/thongbao';
import {Sessioncommand} from '../../../global/sessioncommand';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import {ThongBaoFileXuLyService} from '../../../service/info/service-thongbaofilexuly';
import {ThongBaoComment} from '../../../models/info/thongbaocomment';
import {ThongBaoCommentService} from '../../../service/info/service-thongbaocomment';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {FormatService} from '../../../service/format/service-format';
import {RolePermissionService} from '../../../service/security/service-rolepermission';

@Component({
  templateUrl: './read.component.html'

})
export class ReadThongBaoComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  private moduleName:  string = 'egov.info.thongbao.doc';
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public language = language;
  public id: number=0;
  public thongBao: ThongBao = new ThongBao();
  public thongBaoFiles: ThongBaoFile[] = [];
  public thongBaoCommentList: ThongBaoComment[] = [];
  public frmGroup: FormGroup;
  public submitValidate = false;
  public editor = ClassicEditor;
  public fileLists: Object[]=[];
  public  onClose: Subject<boolean>;
  public uploadUrl: String;
  public deleteUrl: String;
  public permissionDocThongBao: boolean = false;
  public dateCurrent: Date = new Date();
  public urlExportThongBao: string = environment.exportThongBao;
  public urlPrintThongBao: string= environment.printThongBao;
  constructor(  public thongBaoService: ThongBaoService,
                public thongBaoFileXuLyService: ThongBaoFileXuLyService,
                public bsModalService: BsModalService,
                public thongBaoCommentService: ThongBaoCommentService,
                public thongBaoFileService: ThongBaoFileService,
                public datepipe: DatePipe,
                public toastr: ToastrService,
                public _bsModalRef: BsModalRef,
                public formBuilder: FormBuilder,
                public commandUtil: CommandUtil,
                public rolePermissionService: RolePermissionService,
                public formatService: FormatService
  ) {
  }
  ngAfterViewInit() {

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public edit(id: number) {
    this.id = id;
    this.thongBaoService.getByStaffReadId(id, Sessioncommand.staffId).pipe(first())
            .subscribe(x => {
              this.thongBao = x;
            });
          this.thongBaoFileService.findAllByThongBaoId(id).subscribe(
            x => {
              this.thongBaoFiles = x;
            });
          this.loadComment(id);
  }
  public loadComment(id: number)
  {
    this.thongBaoCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.thongBaoCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.thongBaoCommentList = data);
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl(this.id),
      traLoi: new FormControl(),
      trangThai: new FormControl(),
      staffId: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      traLoi: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator],
      staffId: ['', Validators.nullValidator]
    });
    this.uploadUrl= this.thongBaoFileXuLyService.urlUpload;
    this.deleteUrl= this.thongBaoFileXuLyService.urlDelete;
    this.rolePermissionService.checkPermissionByCode(Sessioncommand.staffId, this.moduleName,environment.docthongbao
    ).subscribe( x => this.permissionDocThongBao = x);
    this.formatService.getCurrentDateVN().subscribe( x => this.dateCurrent = this.commandUtil.getDate(x));
  }
  get f() { return this.frmGroup.controls; }
  public createItem ()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.question_save_ykien,
        language.yes,
        language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.frmGroup.value.id = this.id;
        this.frmGroup.value.trangThai = 1;
        this.frmGroup.value.staffId = Sessioncommand.staffId;
        this.thongBaoService.updateXuLy(this.frmGroup.value).subscribe(
            {    next: (data) => {
                if(data !== -1) {
                  this.uploadFileComponent.id = data;
                  this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
                  this.toastr.success(language.message_ykien_success, language.message);
                }else
                  this.toastr.warning(language.error_message_success, language.message);
                this.onSave();
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
      }
    });
  }
  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
      this.createItem();
    this.onClose.next(true);


  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }
}

